
































import { defineComponent, ref, computed } from '@vue/composition-api';
import { nanoid } from 'nanoid';
import DefaultIllustration from './assets/image-file.svg';
import InvalidIllustration from './assets/not-supported.svg';

export default defineComponent({
  name: 'BaseDropzoneV2',
  components: {
    DefaultIllustration,
    InvalidIllustration,
  },
  props: {
    acceptedFileTypes: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const inputValue = ref('');
    const validFile = ref(true);

    const uuid = nanoid(5);
    const dropzoneId = computed(() => props.id || `dropzone-${uuid}`);

    const update = (files: File[]) => {
      emit('update:model-value', files);
    };

    const handleFileInput = (event: Event) => {
      if (props.disabled) {
        return;
      }
      const { files } = event.target as HTMLInputElement;

      if (!files?.length) {
        return;
      }

      if (props.multiple) {
        handleMultipleFilesUpload(files);
        return;
      }

      validFile.value = validateFileType(files[0]);

      if (!validFile.value) {
        emit('error', [files[0].name]);
        return;
      }
      update([files[0]]);
      inputValue.value = '';
    };

    const handleDrop = (event: DragEvent) => {
      if (props.disabled) {
        return;
      }

      if (!event.dataTransfer?.files.length) {
        return;
      }

      if (props.multiple) {
        handleMultipleFilesUpload(event.dataTransfer.files);
        return;
      }

      validFile.value = validateFileType(event.dataTransfer.files[0]);

      if (!validFile.value) {
        emit('error', [event.dataTransfer.files[0].name]);
        return;
      }
      update([event.dataTransfer.files[0]]);
    };

    const handleMultipleFilesUpload = (files: FileList) => {
      const validFiles: File[] = [];
      const invalidFiles: string[] = [];

      for (let index = 0; index < files.length; index++) {
        const validFile = validateFileType(files[index]);
        if (!validFile) {
          invalidFiles.push(files[index].name);
        } else {
          validFiles.push(files[index]);
        }
      }

      update(validFiles);

      if (invalidFiles.length) {
        emit('error', invalidFiles);
        validFile.value = false;
      } else {
        validFile.value = true;
      }
    };

    const validateFileType = (file: File): boolean => {
      const fileName: string = file?.name || '';
      const dotIndex: number = fileName.lastIndexOf('.');
      if (dotIndex < 0) {
        return false;
      }
      const fileType: string = fileName.substr(dotIndex).toLowerCase();

      return props.acceptedFileTypes ? props.acceptedFileTypes.includes(fileType) : true;
    };

    return {
      handleFileInput,
      handleDrop,
      handleMultipleFilesUpload,
      validateFileType,
      update,
      validFile,
      dropzoneId,
      inputValue,
    };
  },
});
